import { FormControl } from '@/components/ui/form'
import { useContext, useLayoutEffect } from 'react'
import { FormContext } from '../FormProvider'
import { FormFieldProps, FormSelectType } from './type'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

export const FormSelectField = ({
  data,
  field,
}: FormFieldProps<FormSelectType>) => {
  const context = useContext(FormContext)

  return (
    <Select
      value={field.value?.toString()}
      onValueChange={(v) => {
        let _v: any = v
        if (typeof data.options[0].value === 'number') {
          _v = Number(v)
        }
        field.onChange(_v)
      }}
      defaultValue={
        field.value?.toString() ||
        (typeof data.default === 'function'
          ? data.default?.(context.modifyTarget)
          : data.default
        )?.toString()
      }
      disabled={data.readOnly}
    >
      <FormControl>
        <SelectTrigger className="max-w-[500px] disabled:border-none disabled:opacity-75 disabled:shadow-none">
          <SelectValue placeholder={data.placeholder || data.label} />
        </SelectTrigger>
      </FormControl>
      <SelectContent>
        {data.options.map((option) => {
          return (
            <SelectItem key={option.value} value={option.value.toString()}>
              {option.label || option.value}
            </SelectItem>
          )
        })}
      </SelectContent>
    </Select>
  )
}
